import AttendStampAggregation from "./AttendStampAggregation";

export default AttendStampAggregation;
